// baby: Re-export shared 8-bit UI primitives
export {
  Ninxl8BitHud,
  Ninxl8BitFrame,
  Ninxl8BitSection,
  Ninxl8BitDivider,
} from '@/app/(marketing)/_components/8bit'
